import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomRight32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRadiusBottomRight32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.949 24.742h4.822a9 9 0 0 0 9-9V10.82a1 1 0 1 1 2 0v4.922c0 6.075-4.925 11-11 11h-4.822a1 1 0 0 1 0-2m-4.457-7.763a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m-1.25 3.762a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m16-13.512a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M8.991 5.98a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m6.75 1.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m-10.5 3.79a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomRight32);
